export default "__VITE_ASSET__DPS6OJMX__"